import { fillLayers, pick, type LayerStyle } from "./types";

const CONTRIBUTING = "#3b8f4e";

const style: LayerStyle = {
  id: "edwards-contributing",
  minzoom: 8,
  maxzoom: 14,
  layers(source) {
    return fillLayers(this, source, CONTRIBUTING, 0.2);
  },
  legend: [{ label: "Contributing zone", color: CONTRIBUTING }],
  describe: (p) =>
    pick(p, [
      ["CONTRIBUTING_ZONE", "Contributing zone"],
      ["WATERSHED_NAME", "Watershed"],
    ]),
};

export default style;
